export default __webpack_public_path__ + "media/images/svg/fb_icon-717dd69a68bed9cd93c76921eb969e79.svg";